import { DocumentObjectListRefTableEnum } from '@/constant';
import { GetCommonDocumentObjectListParams } from '@/services';
import {
	CommonActions,
	CommonSelectors,
	useAppDispatch,
	useAppSelector,
} from '@/stores';
import { useEffect, useMemo } from 'react';

export const useDocumentObjectList = <TObjectList>(
	refTableName?: DocumentObjectListRefTableEnum,
	shouldCallApi: boolean = true,
	paramsSearch?: Omit<GetCommonDocumentObjectListParams, 'refTableName'>
) => {
	const dispatch = useAppDispatch();
	const documentObjectList = useAppSelector(CommonSelectors.documentObjectList);

	const dataList = useMemo(() => {
		if (refTableName && documentObjectList[refTableName]) {
			return documentObjectList[refTableName] as {
				fetching: boolean;
				data: TObjectList[];
			};
		}
		return { fetching: false, data: [] };
	}, [documentObjectList, refTableName]);

	const params = useMemo(() => {
		return paramsSearch ? paramsSearch : {};
	}, [paramsSearch]);

	useEffect(() => {
		if (refTableName && shouldCallApi) {
			dispatch(
				CommonActions.getDocumentObjectListRequest({ refTableName, ...params })
			);
		}
	}, [refTableName, shouldCallApi, params]);

	return dataList;
};
